export default __webpack_public_path__ + "assets/70f0d7b0ecbe585bf7f2536fe4c93d04.png";